<template>
  <v-dialog
    v-model="opened"
    content-class="weekend-schedule-dialog"
    max-width="350"
    persistent
  >
    <h3>{{ title }}</h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form ref="weekend-schedule-form" class="weekend-schedule-dialog__form">
      <v-text-field
        v-model="formData.name"
        outlined
        dense
        :label="$t('weekendScheldule.name')"
        :rules="[isRequired]"
      />
      <v-text-field
        v-model="formData.workdays_count"
        outlined
        dense
        :label="$t('weekendScheldule.workDays')"
        :rules="[isRequired, onlyNumbers]"
      />
      <v-text-field
        v-model="formData.weekend_count"
        outlined
        dense
        :label="$t('weekendScheldule.weekend')"
        :rules="[isRequired, onlyNumbers]"
      />
      <v-text-field
        v-model="formData.description"
        outlined
        dense
        :label="$t('common.table.description')"
      />

      <v-btn
        color="warning"
        elevation="0"
        block
        :loading="loading"
        @click="onSubmit"
      >
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: [Object, null],
      default: null,
    },
  },
  data: () => ({
    loading: false,
    formData: {
      name: '',
      workdays_count: '',
      weekend_count: '',
      description: '',
    },
  }),
  watch: {
    opened(val) {
      if (val) return;

      setTimeout(() => {
        this.$refs['weekend-schedule-form'].reset();
        this.$emit('update:edit-data', null);
      }, 300);
    },
    editData(data) {
      if (!data) return;
      this.fillForm(data);
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    title() {
      return this.editData
        ? this.$t('common.btns.edit')
        : this.$t('weekendScheldule.add');
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    onlyNumbers(v) {
      if (!v) return true;
      return (
        /^[0-9]{1,12}$/.test(v) || this.$t('common.fields.validation.numbers')
      );
    },
    fillForm(data) {
      this.formData.name = data.name;
      this.formData.workdays_count = data.workdays_count;
      this.formData.weekend_count = data.weekend_count;
      this.formData.description = data.description;
    },
    async onSubmit() {
      const isValid = this.$refs['weekend-schedule-form'].validate();

      if (!isValid) return;

      this.loading = true;
      const result = await this.sendRequest();

      this.$emit('update', result);
      this.loading = false;
    },
    sendRequest() {
      if (this.editData) {
        return this.$store.dispatch('weekend-schedule/updateItem', {
          id: this.editData.id,
          params: this.formData,
        });
      }

      return this.$store.dispatch('weekend-schedule/addNew', this.formData);
    },
  },
};
</script>

<style lang="scss">
.weekend-schedule-dialog {
  padding: 10px;
  background-color: #fff;

  &__form {
    margin-top: 20px;
  }
}
</style>
